import { InjectionToken } from '@angular/core';

export interface CapicheUiConfig {
  /**
   * CSW-1651: base URL for capicheAdminApi's /auth/* routes — used by
   * CurrentUserComponent to fetch a student's display profile (GET
   * /auth/me) after a hard refresh, when the in-memory cache set at login
   * (see StudentDisplayService) is gone. Optional: apps that never show a
   * student-authenticated view (e.g. the admin portal) don't need to
   * provide it, and CurrentUserComponent just skips the fetch.
   */
  baseEducationApiUrl?: string;
}

export const CAPICHE_UI_CONFIG = new InjectionToken<CapicheUiConfig>('CapicheUiConfig', {
  factory: () => ({}),
});
